import React, { useEffect, useRef, useState } from "react";
import Book from "./Book"
import DatePicker from "react-multi-date-picker";
import CountUp from 'react-countup';
import Handler from "../Helpers/Components/Handler";
import moment from "moment";

const Dashboard = () => {
    const latestRequest = useRef(0);
    const [search, setSearch] = useState(false);
    const [chosen, setChosen] = useState("today")
    const [count, setCount] = useState({ customer: 0, booking: 0, collection: 0, ec: 0, nc: 0, delivery: 0, pickup: 0, deliveryPending: 0, pickupPending: 0, cancelled: 0, pending: 0, verified: 0, partial: 0, unverified: 0 })
    const [dateRange, setDateRange] = useState({ from: new Date(), to: new Date() })
    const [start, setStart] = useState(new Date())
    const [end, setEnd] = useState(new Date())
    const [loading, setLoading] = useState(false)

    const getCount = async () => {
        const requestId = ++latestRequest.current;
        setLoading(true)
        const response = await Handler({ method: 'post', url: `/booking/dashboard`, data: { chosen, ...(chosen === "customize" ? { from: dateRange?.from || new Date(), to: dateRange?.to || dateRange?.from || new Date() } : {}) } });
        if (requestId !== latestRequest.current) return;
        if (response?.success) {
            setCount(response?.data)
        } else {
            setCount({ customer: 0, booking: 0, collection: 0, delivery: 0, pickup: 0, cancelled: 0, pending: 0, verified: 0, partial: 0, unverified: 0, deliveryPending: 0, pickupPending: 0, lead: 0 })
        }
        setLoading(false)
    }
    useEffect(() => {
        getCount()
    }, [chosen, dateRange])
    useEffect(() => {
        if (chosen === "today") {
            setStart(new Date(new Date()?.setHours(0, 0, 0, 0)))
            setEnd(new Date(new Date()?.setHours(23, 59, 59, 999)))
        }
        if (chosen === "week") {
            const current = new Date();
            const day = current.getUTCDay();
            const weekStart = new Date(current);
            weekStart.setUTCDate(current.getUTCDate() - day);
            const weekEnd = new Date(current);
            weekEnd.setUTCDate(current.getUTCDate() - day + 6);
            setStart(new Date(weekStart.getUTCFullYear(), weekStart.getUTCMonth(), weekStart.getUTCDate(), 0, 0, 0, 0));
            setEnd(new Date(weekEnd.getUTCFullYear(), weekEnd.getUTCMonth(), weekEnd.getUTCDate(), 23, 59, 59, 999));
        }
        if (chosen === "month") {
            const CUTOFF_DAY = 25;
            const CUTOFF_HOUR = 18;
            const current = new Date();
            let startMonth = current.getUTCMonth();
            let startYear = current.getUTCFullYear();
            if (current.getUTCDate() < CUTOFF_DAY || (current.getUTCDate() === CUTOFF_DAY && current.getUTCHours() < CUTOFF_HOUR)) {
                startMonth -= 1;
                if (startMonth < 0) {
                    startMonth = 11;
                    startYear -= 1;
                }
            }
            setStart(new Date(startYear, startMonth, CUTOFF_DAY, CUTOFF_HOUR, 0, 0, 0));
            setEnd(new Date(startYear, startMonth + 1, CUTOFF_DAY, CUTOFF_HOUR, 0, 0, 0));
        }
        if (chosen === "quarter") {
            const CUTOFF_DAY = 25;
            const CUTOFF_HOUR = 18;
            const current = new Date();
            let startMonth = current.getUTCMonth();
            let startYear = current.getUTCFullYear();
            if (current.getUTCDate() < CUTOFF_DAY || (current.getUTCDate() === CUTOFF_DAY && current.getUTCHours() < CUTOFF_HOUR)) {
                startMonth -= 3;
            }
            while (startMonth < 0) {
                startMonth += 12;
                startYear -= 1;
            }
            setStart(new Date(startYear, startMonth, CUTOFF_DAY, CUTOFF_HOUR, 0, 0, 0));
            setEnd(new Date(startYear, startMonth + 3, CUTOFF_DAY, CUTOFF_HOUR, 0, 0, 0));
        }
        if (chosen === "year") {
            setStart(new Date(new Date().getUTCFullYear(), 0, 1, 0, 0, 0, 0));
            setEnd(new Date(new Date().getUTCFullYear(), 11, 31, 23, 59, 59, 999));
        }
        if (chosen === "customize" && dateRange?.from) {
            setStart(new Date(new Date(dateRange.from).setHours(0, 0, 0, 0)));
            setEnd(new Date(new Date(dateRange.to || dateRange.from).setHours(23, 59, 59, 999)));
        }
    }, [chosen, dateRange])
    return (
        <React.Fragment>
            <div className="layout-card">
                <div className="row mb-4 justify-content-center">
                    <div className="col-lg-5">
                        <div className="btn-group d-flex flex-column flex-lg-row" role="group" aria-label="Basic mixed styles example">
                            <button type="button" className={`btn dashboard-btns ${!search ? "active-dashboard-btns" : ""}`} onClick={() => setSearch(false)}>Dashboard</button>
                            <button type="button" className={`btn dashboard-btns ${search ? "active-dashboard-btns" : ""}`} onClick={() => setSearch(true)}>Search</button>
                        </div>
                    </div>
                    {/* <div className="col-lg-3">
                        <button><i className="fa-solid fa-download"></i></button>
                    </div> */}
                </div>
                {
                    search ?
                        <Book />
                        :
                        <>
                            <div className="mb-3 text-center fw-bold fs-5">
                                {moment(start)?.format("DD/MM/YYYY hh:mm A")} - {moment(end)?.format("DD/MM/YYYY hh:mm A")}
                            </div>
                            <div className="text-center mb-4">
                                <div className="btn-group d-flex flex-column flex-lg-row" role="group" aria-label="Basic mixed styles example">
                                    <button type="button" className={`btn dashboard-btns ${chosen === "today" ? "active-dashboard-btns" : ""}`} onClick={() => { setChosen("today") }}>Today</button>
                                    <button type="button" className={`btn dashboard-btns ${chosen === "week" ? "active-dashboard-btns" : ""}`} onClick={() => setChosen("week")}>This Week</button>
                                    <button type="button" className={`btn dashboard-btns ${chosen === "month" ? "active-dashboard-btns" : ""}`} onClick={() => setChosen("month")}>This Month</button>
                                    <button type="button" className={`btn dashboard-btns ${chosen === "quarter" ? "active-dashboard-btns" : ""}`} onClick={() => setChosen("quarter")}>This Quarter</button>
                                    <button type="button" className={`btn dashboard-btns ${chosen === "year" ? "active-dashboard-btns" : ""}`} onClick={() => setChosen("year")}>This Year</button>
                                    <button type="button" className={`btn dashboard-btns ${chosen === "customize" ? "active-dashboard-btns" : ""}`} onClick={() => { setChosen("customize"); setDateRange({ from: new Date(), to: new Date() }) }}>Customize</button>
                                    {/* <button type="button" className={`btn dashboard-btns ${chosen === "total" ? "active-dashboard-btns" : ""}`} onClick={() => setChosen("total")}>Total</button> */}
                                </div>
                            </div>
                            {
                                chosen === "customize"
                                    ?
                                    <div className="mt-4 justify-content-center row">
                                        <div className="d-md-flex align-items-center col-lg-4 col-md-8">
                                            <div className="me-2 filter-date datepicker-top">
                                                <DatePicker
                                                    autoComplete="off"
                                                    selected={dateRange?.from}
                                                    id="from"
                                                    timeIntervals={15}
                                                    showYearDropdown
                                                    value={dateRange?.from || ""}
                                                    showMonthDropdown
                                                    placeholderText="From"
                                                    onChange={(date) => setDateRange((prevValues) => ({ ...prevValues, from: date }))}
                                                    dateFormat="dd/MM/yyyy"
                                                    className="form-control form_input text-uppercase me-2"
                                                />
                                            </div>
                                            <div className="me-2 filter-date datepicker-top">
                                                <DatePicker
                                                    autoComplete="off"
                                                    selected={dateRange?.to}
                                                    showYearDropdown
                                                    showMonthDropdown
                                                    id="from"
                                                    placeholderText="To"
                                                    timeIntervals={15}
                                                    value={dateRange?.to || ""}
                                                    onChange={(date) => setDateRange((prevValues) => ({ ...prevValues, to: date }))}
                                                    dateFormat="dd/MM/yyyy"
                                                    minDate={dateRange?.from}
                                                    disabled={dateRange?.from === "" ? true : false}
                                                    className="form-control form_input text-uppercase"
                                                />
                                            </div>
                                            {dateRange?.from === "" ? "" :
                                                <div className="mb-md-0 mb-2">
                                                    <button className="py-0 px-1 d-flex align-items-center btn btn-danger" onClick={() => { setDateRange({ from: new Date(), to: new Date() }); }}>
                                                        <i className='fa-xmark fa-solid'></i>
                                                    </button></div>}
                                        </div>
                                    </div>
                                    : ""
                            }
                            <div className="mt-4 row">
                                <div className="col-xl-3 mt-3 col-md-6 col-12">
                                    <div className="dashboardCard card">
                                        <div className="card-body">
                                            <div className="d-flex align-items-center">
                                                <div className="flex-grow-1 overflow-hidden ms-3">
                                                    <p className="fw-medium text-muted mb-3">New Customers</p>
                                                    <h4 className="fs-4 flex-grow-1 mb-0 d-flex justify-content-between">
                                                        {loading ? <i className="fa-solid fa-spinner fa-spin text-theme"></i> : <CountUp end={count?.customer} duration={2} className="text-theme" />}
                                                        <i className="fa-solid fa-person fs-2" style={{ "color": "black", "backgroundColor": "#fff" }}></i>
                                                    </h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-3 mt-3 col-md-6 col-12">
                                    <div className="dashboardCard card">
                                        <div className="card-body">
                                            <div className="d-flex align-items-center">
                                                <div className="flex-grow-1 overflow-hidden ms-3">
                                                    <p className="fw-medium text-muted mb-3">Bookings</p>
                                                    <h4 className="fs-4 flex-grow-1 mb-0 d-flex justify-content-between">
                                                        {loading ? <i className="fa-solid fa-spinner fa-spin text-theme"></i> : <CountUp end={count?.booking} duration={2} className="text-theme" />}
                                                        <i className="fa-solid fa-book-open-reader fs-2" style={{ "color": "black", "backgroundColor": "#fff" }}></i>
                                                    </h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-3 mt-3 col-md-6 col-12">
                                    <div className="dashboardCard card">
                                        <div className="card-body">
                                            <div className="d-flex align-items-center">
                                                <div className="flex-grow-1 overflow-hidden ms-3">
                                                    <p className="fw-medium text-muted mb-3">New Cust Bookings</p>
                                                    <h4 className="fs-4 flex-grow-1 mb-0 d-flex justify-content-between">
                                                        {loading ? <i className="fa-solid fa-spinner fa-spin text-theme"></i> : <CountUp end={count?.newBookings} duration={2} className="text-theme" />}
                                                        <i className="fa-solid fa-book-open-reader fs-2" style={{ "color": "black", "backgroundColor": "#fff" }}></i>
                                                    </h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-3 mt-3 col-md-6 col-12">
                                    <div className="dashboardCard card">
                                        <div className="card-body">
                                            <div className="d-flex align-items-center">
                                                <div className="flex-grow-1 overflow-hidden ms-3">
                                                    <p className="fw-medium text-muted mb-3">Existing Cust Bookings</p>
                                                    <h4 className="fs-4 flex-grow-1 mb-0 d-flex justify-content-between">
                                                        {loading ? <i className="fa-solid fa-spinner fa-spin text-theme"></i> : <CountUp end={count?.oldBookings} duration={2} className="text-theme" />}
                                                        <i className="fa-solid fa-book-open-reader fs-2" style={{ "color": "black", "backgroundColor": "#fff" }}></i>
                                                    </h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="mt-4 row">
                                <div className="col-xl-3 mt-3 col-md-6 col-12">
                                    <div className="dashboardCard card">
                                        <div className="card-body">
                                            <div className="d-flex align-items-center">
                                                <div className="flex-grow-1 overflow-hidden ms-3">
                                                    <p className="fw-medium text-muted mb-3">Delivery Completed</p>
                                                    <h4 className="fs-4 flex-grow-1 mb-0 d-flex justify-content-between">
                                                        {loading ? <i className="fa-solid fa-spinner fa-spin text-theme"></i> : <CountUp end={count?.delivery} duration={2} className="text-theme" />}
                                                        <i className="fa-solid fa-location-dot fs-2" style={{ "color": "black", "backgroundColor": "#fff" }}></i>
                                                    </h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-3 mt-3 col-md-6 col-12">
                                    <div className="dashboardCard card">
                                        <div className="card-body">
                                            <div className="d-flex align-items-center">
                                                <div className="flex-grow-1 overflow-hidden ms-3">
                                                    <p className="fw-medium text-muted mb-3">Delivery Pending</p>
                                                    <h4 className="fs-4 flex-grow-1 mb-0 d-flex justify-content-between">
                                                        {loading ? <i className="fa-solid fa-spinner fa-spin text-theme"></i> : <CountUp end={count?.deliveryPending} duration={2} className="text-theme" />}
                                                        <i className="fa-solid fa-location-dot fs-2" style={{ "color": "black", "backgroundColor": "#fff" }}></i>
                                                    </h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-3 mt-3 col-md-6 col-12">
                                    <div className="dashboardCard card">
                                        <div className="card-body">
                                            <div className="d-flex align-items-center">
                                                <div className="flex-grow-1 overflow-hidden ms-3">
                                                    <p className="fw-medium text-muted mb-3">Pickup Completed</p>
                                                    <h4 className="fs-4 flex-grow-1 mb-0 d-flex justify-content-between">
                                                        {loading ? <i className="fa-solid fa-spinner fa-spin text-theme"></i> : <CountUp end={count?.pickup} duration={2} className="text-theme" />}
                                                        <i className="fa-solid fa-location-dot fs-2" style={{ "color": "black", "backgroundColor": "#fff" }}></i>
                                                    </h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-3 mt-3 col-md-6 col-12">
                                    <div className="dashboardCard card">
                                        <div className="card-body">
                                            <div className="d-flex align-items-center">
                                                <div className="flex-grow-1 overflow-hidden ms-3">
                                                    <p className="fw-medium text-muted mb-3">Pickup Pending</p>
                                                    <h4 className="fs-4 flex-grow-1 mb-0 d-flex justify-content-between">
                                                        {loading ? <i className="fa-solid fa-spinner fa-spin text-theme"></i> : <CountUp end={count?.pickupPending} duration={2} className="text-theme" />}
                                                        <i className="fa-solid fa-location-dot fs-2" style={{ "color": "black", "backgroundColor": "#fff" }}></i>
                                                    </h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="mt-4 row justify-content-center">
                                <div className="col-xl-3 mt-3 col-md-6 col-12">
                                    <div className="dashboardCard card">
                                        <div className="card-body">
                                            <div className="d-flex align-items-center">
                                                <div className="flex-grow-1 overflow-hidden ms-3">
                                                    <p className="fw-medium text-muted mb-3">Cancelled</p>
                                                    <h4 className="fs-4 flex-grow-1 mb-0 d-flex justify-content-between">
                                                        {loading ? <i className="fa-solid fa-spinner fa-spin text-theme"></i> : <CountUp end={count?.cancelled} duration={2} className="text-theme" />}
                                                        <i className="fa-solid fa-xmark fs-2" style={{ "color": "black", "backgroundColor": "#fff" }}></i>
                                                    </h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-3 mt-3 col-md-6 col-12">
                                    <div className="dashboardCard card">
                                        <div className="card-body">
                                            <div className="d-flex align-items-center">
                                                <div className="flex-grow-1 overflow-hidden ms-3">
                                                    <p className="fw-medium text-muted mb-3">Pending</p>
                                                    <h4 className="fs-4 flex-grow-1 mb-0 d-flex justify-content-between">
                                                        {loading ? <i className="fa-solid fa-spinner fa-spin text-theme"></i> : <CountUp end={count?.pending} duration={1} className="text-theme" />}
                                                        <i className="fa-solid fa-hourglass-start fs-2" style={{ "color": "black", "backgroundColor": "#fff" }}></i>
                                                    </h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="mt-4 row justify-content-center">
                                <div className="col-xl-3 mt-3 col-md-6 col-12">
                                    <div className="dashboardCard card">
                                        <div className="card-body">
                                            <div className="d-flex align-items-center">
                                                <div className="flex-grow-1 overflow-hidden ms-3">
                                                    <p className="fw-medium text-muted mb-3">Verified Customer</p>
                                                    <h4 className="fs-4 flex-grow-1 mb-0 d-flex justify-content-between">
                                                        {loading ? <i className="fa-solid fa-spinner fa-spin text-theme"></i> : <CountUp end={count?.verified} duration={2} className="text-theme" />}
                                                        <i className="fa-solid fa-check fs-2" style={{ "color": "black", "backgroundColor": "#fff" }}></i>
                                                    </h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-3 mt-3 col-md-6 col-12">
                                    <div className="dashboardCard card">
                                        <div className="card-body">
                                            <div className="d-flex align-items-center">
                                                <div className="flex-grow-1 overflow-hidden ms-3">
                                                    <p className="fw-medium text-muted mb-3">Partially Verified Customer</p>
                                                    <h4 className="fs-4 flex-grow-1 mb-0 d-flex justify-content-between">
                                                        {loading ? <i className="fa-solid fa-spinner fa-spin text-theme"></i> : <CountUp end={count?.partial} duration={2} className="text-theme" />}
                                                        <i className="fa-solid fa-hourglass-start fs-2" style={{ "color": "black", "backgroundColor": "#fff" }}></i>
                                                    </h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-3 mt-3 col-md-6 col-12">
                                    <div className="dashboardCard card">
                                        <div className="card-body">
                                            <div className="d-flex align-items-center">
                                                <div className="flex-grow-1 overflow-hidden ms-3">
                                                    <p className="fw-medium text-muted mb-3">Unverified Customer</p>
                                                    <h4 className="fs-4 flex-grow-1 mb-0 d-flex justify-content-between">
                                                        {loading ? <i className="fa-solid fa-spinner fa-spin text-theme"></i> : <CountUp end={count?.unverified} duration={1} className="text-theme" />}
                                                        <i className="fa-solid fa-xmark fs-2" style={{ "color": "black", "backgroundColor": "#fff" }}></i>
                                                    </h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="mt-4 row justify-content-center">
                                <div className="col-xl-3 mt-3 col-md-6 col-12">
                                    <div className="dashboardCard card">
                                        <div className="card-body">
                                            <div className="d-flex align-items-center">
                                                <div className="flex-grow-1 overflow-hidden ms-3">
                                                    <p className="fw-medium text-muted mb-3">Leads</p>
                                                    <h4 className="fs-4 flex-grow-1 mb-0 d-flex justify-content-between">
                                                        {loading ? <i className="fa-solid fa-spinner fa-spin text-theme"></i> : <CountUp end={count?.leads || 0} duration={2} className="text-theme" />}
                                                        <i className="fa-solid fa-check fs-2" style={{ "color": "black", "backgroundColor": "#fff" }}></i>
                                                    </h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-3 mt-3 col-md-6 col-12">
                                    <div className="dashboardCard card">
                                        <div className="card-body">
                                            <div className="d-flex align-items-center">
                                                <div className="flex-grow-1 overflow-hidden ms-3">
                                                    <p className="fw-medium text-muted mb-3">Leads Converted</p>
                                                    <h4 className="fs-4 flex-grow-1 mb-0 d-flex justify-content-between">
                                                        {loading ? <i className="fa-solid fa-spinner fa-spin text-theme"></i> : <CountUp end={count?.lead} duration={1} className="text-theme" />}
                                                        <i className="fa-solid fa-xmark fs-2" style={{ "color": "black", "backgroundColor": "#fff" }}></i>
                                                    </h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                }
            </div>
        </React.Fragment>
    )
}

export default Dashboard;